exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#app{font-family:Avenir,Helvetica,Arial,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-311c8c74!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/CrematoryOverview.vue
// module id = 366
// module chunks = 0